import React from 'react';

// alt + i   < start / stop timer
// wont work in fullscreen because next arrows are hidden.

// need to timeout for assets to load... [HACK]
const INTRO_DELAY = 2000;

// const windowHref = window.location.href.split('?');
// [1].split('=');

const SLIDE_SECONDS = 30; // 20 seconds a slide

let IGNITE = false;
let SECONDS_LEFT = SLIDE_SECONDS;
let NEXT_BUTTON;

export default class Timer extends React.Component {

  constructor() {
    super();
    this.state = {
      remaining: SLIDE_SECONDS,
      ignite: false,
    };
  }

  componentDidMount() {
    console.log('mounted timer');
    if (!this.nextButton) {
      setTimeout(() => {
      // NEXT_BUTTON = document.querySelector('[aria-label="Next slide"]');
      this.nextButton = document.querySelector('[aria-label="Next slide"]');
      // console.log(NEXT_BUTTON);
      console.log(this.nextButton);
      window.addEventListener('keydown', e => {
        if (e.altKey && e.keyCode === 73) {
          // IGNITE = !IGNITE;
          this.setState({
            ignite: !this.state.ignite,
          });
          if (this.state.ignite) {
            console.log('Starting ignite')
            // ignite(NEXT_BUTTON, SLIDE_SECONDS, () => this.forceUpdate());



            const timeLeft = setInterval(() => {
              if (this.state.ignite) {
                // SECONDS_LEFT = SECONDS_LEFT - 1;
                console.log('remaining: ', this.state.remaining);
                this.setState({
                  remaining: this.state.remaining - 1,
                });
              } else {
                this.setState({
                  remaining: SLIDE_SECONDS,
                });
                clearTimeout(timeLeft);
              }
            }, 1001);

            const igniteInterval = setInterval(() => {
              if (this.state.ignite) {
                this.nextButton.click();
                // reset timer
                // SECONDS_LEFT = SLIDE_SECONDS;
                this.setState({
                  remaining: SLIDE_SECONDS,
                });
              } else {
                clearTimeout(igniteInterval);
              }
            }, SLIDE_SECONDS * 1000);




          } else {
            console.log('Ending ignite');
          }
        }
      });
    }, 5000); // wait for window to load...
    }
  }

  render() {
    if (!this.state.ignite) return null;
    return (
      <div style={{position: 'absolute', bottom: 0, right: 0, padding: '20px'}}>
        <span style={{color: 'rgba(100, 100, 100, 0.5)', fontSize: '2em'}}>
          {this.state.remaining}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/timer.js